import { Form } from "react-bootstrap";
import { useId } from "react";
import { useContextValues } from "../../context/RouteDataContext.jsx";

export default function StopsUnitForm() {
  const { stopsUnit, setStopsUnit } = useContextValues();
  const uid = useId();
  const groupName = `stops-unit-${uid}`;

  const handleChange = (e) => {
    setStopsUnit(e.target.value);
  };

  return (
    <Form.Group as="fieldset" aria-label="Select types of stops to display">
      <legend className="visually-hidden">Select types of stops to display</legend>
      <div className="stops-toggle">
        <Form.Check
          inline
          type="radio"
          name={groupName}
          id={`stops-all-${uid}`}
          value="all"
          checked={stopsUnit === "all"}
          onChange={handleChange}
          label="All stops"
          reverse
        />
        <Form.Check
          inline
          type="radio"
          name={groupName}
          id={`stops-timepoints-${uid}`}
          value="timepoints"
          checked={stopsUnit === "timepoints"}
          onChange={handleChange}
          label="Timepoints"
          reverse
        />
      </div>
    </Form.Group>
  );
}
